export default __webpack_public_path__ + "static/media/arrow-bottom-light-blue-icon.b0990574.svg";